import * as Yup from "yup";

export const signUpDetailsObject = {
  email: "",
  first_name: "",
  gender: "",
  last_name: "",
  password1: "",
  password2: "",
  username: "",
};

export function objectFromFormData(formData) {
  return {
    _id: formData.id || "",
    username: formData.username,
    email: formData.email,
    password1: formData.password2,
    first_name: formData.first_name,
    last_name: formData.last_name,
    gender: formData.gender,
    email: formData.email,
  };
}

export function objectFromResponseData(data) {
  return {
    id: data._id,
    email: data.email || "",
    first_name: data.first_name || "",
    gender: data.gender || "",
    last_name: data.last_name || "",
    password1: "",
    password2: "",
    username: "",
    phoneno: data.mobile,
  };
}

export const formDisplayValidationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters"),

  last_name: Yup.string().min(2, "Last name must be at least 2 characters"),

  gender: Yup.string().required("Gender is required"),

  email: Yup.string()
    .required("Email is required")
    .email("Enter a valid email address"),

  username: Yup.string()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters"),

  password1: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),

  password2: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password1"), null], "Passwords must match"),
});
